import { NotificationTypeAction, TicketLabelsActionType } from '.';
import { ArticleType, ContentTaskPriority, ContentTaskType } from '..';
import { ExtendedCallStatus } from '../call-center';
export var ALL_TASK_TYPES = [ContentTaskType.REVIEW, ContentTaskType.WRITE, ContentTaskType.UPDATE];
export var ALL_PRIORITIES = [ContentTaskPriority.HIGH, ContentTaskPriority.MEDIUM, ContentTaskPriority.LOW];
export var ALL_ARTICLE_TYPES = [ArticleType.ARTICLE, ArticleType.KNOWN_ISSUE, ArticleType.FEATURE_REQUEST];
export var ALL_NOTIFICATION_TYPES = [NotificationTypeAction.EMAIL, NotificationTypeAction.IN_APP_NOTIFICATION, NotificationTypeAction.SLACK];
export var LABELS_ACTION_OPERATIONS = [TicketLabelsActionType.ADD, TicketLabelsActionType.REMOVE, TicketLabelsActionType.REPLACE];
export var ALL_CALL_RESULT_TYPES = [
    ExtendedCallStatus.NO_ANSWER,
    ExtendedCallStatus.ABANDONED,
    ExtendedCallStatus.FAILED,
    ExtendedCallStatus.HUNG_UP_IN_QUEUE,
    ExtendedCallStatus.HUNG_UP_IN_IVR,
];
//# sourceMappingURL=constants.js.map